import { Button, Form, Modal } from 'react-bootstrap';

const ProfileAccountModalPanel = ({ children, onHide, title, footer, confirm }) => (
    <div className={`profile-account-mobile-modal__panel${confirm ? ' profile-account-mobile-modal__panel--confirm' : ''}`}>
        <div className="profile-account-mobile-modal__header">
            <Modal.Title>{title}</Modal.Title>
            <button type="button" className="profile-account-mobile-modal__close" onClick={onHide}
                aria-label="Close account dialog">&times;</button>
        </div>
        {children}
        <div className="profile-account-mobile-modal__footer">{footer}</div>
    </div>
);

const ProfileAccountModals = ({
    isActive, showDeactivateModal, setShowDeactivateModal, handleDeactivate,
    showDeleteModal, setShowDeleteModal, handleDelete,
    showPasswordModal, setShowPasswordModal, handleChangePassword,
    newPwd, setNewPwd, confirmPwd, setConfirmPwd, showNewPwd, setShowNewPwd,
    showConfirmPwd, setShowConfirmPwd, pwdChecks, pwdMatch, pwdMsg, setPwdMsg, pwdLoading,
    icEye, icEyeClosed,
}) => (
    <>
        <Modal show={showDeactivateModal} onHide={() => setShowDeactivateModal(false)} centered
            className="profile-account-mobile-modal">
            <ProfileAccountModalPanel confirm title={isActive ? 'Deactivate account' : 'Activate account'}
                onHide={() => setShowDeactivateModal(false)} footer={
                    <>
                        <Button variant="outline-secondary me-3" onClick={() => setShowDeactivateModal(false)}>Cancel</Button>
                        <Button variant="primary" onClick={handleDeactivate}>{isActive ? 'Deactivate' : 'Activate'}</Button>
                    </>
                }>
                <Modal.Body><p>{isActive
                    ? 'Are you sure you want to deactivate your account?'
                    : 'Are you sure you want to reactivate your account?'
                }</p></Modal.Body>
            </ProfileAccountModalPanel>
        </Modal>

        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered
            className="profile-account-mobile-modal">
            <ProfileAccountModalPanel confirm title="Delete account" onHide={() => setShowDeleteModal(false)} footer={
                <>
                    <Button variant="outline-secondary me-3" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                    <Button variant="danger" onClick={handleDelete}>Delete account</Button>
                </>
            }>
                <Modal.Body><p>Are you sure you want to permanently delete your account? This action cannot be undone.</p></Modal.Body>
            </ProfileAccountModalPanel>
        </Modal>

        <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered
            className="profile-account-mobile-modal">
            <Modal.Header closeButton><Modal.Title>Change password</Modal.Title></Modal.Header>
            <Form onSubmit={handleChangePassword}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>New password</Form.Label>
                            <div style={{ position: 'relative' }}>
                                <Form.Control type={showNewPwd ? 'text' : 'password'} value={newPwd}
                                    onChange={(event) => { setNewPwd(event.target.value); setPwdMsg(''); }} autoComplete="new-password"
                                    placeholder="Enter new password" style={{ paddingRight: '42px' }} />
                                <img src={showNewPwd ? icEye : icEyeClosed} alt="" width={16} height={16}
                                    onClick={() => setShowNewPwd(value => !value)}
                                    style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', opacity: 0.7 }} />
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Label>Confirm new password</Form.Label>
                            <div style={{ position: 'relative' }}>
                                <Form.Control type={showConfirmPwd ? 'text' : 'password'} value={confirmPwd}
                                    onChange={(event) => { setConfirmPwd(event.target.value); setPwdMsg(''); }} autoComplete="new-password"
                                    placeholder="Repeat new password" style={{ paddingRight: '42px' }} />
                                <img src={showConfirmPwd ? icEye : icEyeClosed} alt="" width={16} height={16}
                                    onClick={() => setShowConfirmPwd(value => !value)}
                                    style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', opacity: 0.7 }} />
                            </div>
                        </Form.Group>
                        <div className="mt-3">
                            <div className="mb-2 font-size-sm">Create password that contains at least:</div>
                            <div className="row g-2 font-size-sm">
                                <div className="col-6"><div className={pwdChecks.minLen ? 'text-success' : 'text-danger'}>{pwdChecks.minLen ? '✓' : '✕'} min. 8 characters</div></div>
                                <div className="col-6"><div className={pwdChecks.lower ? 'text-success' : 'text-danger'}>{pwdChecks.lower ? '✓' : '✕'} one lowercase letter</div></div>
                                <div className="col-6"><div className={pwdChecks.upper ? 'text-success' : 'text-danger'}>{pwdChecks.upper ? '✓' : '✕'} one capital letter</div></div>
                                <div className="col-6"><div className={pwdChecks.number ? 'text-success' : 'text-danger'}>{pwdChecks.number ? '✓' : '✕'} one number</div></div>
                                <div className="col-12"><div className={pwdChecks.special ? 'text-success' : 'text-danger'}>{pwdChecks.special ? '✓' : '✕'} one special character</div></div>
                                {pwdMatch !== null && <div className="col-12"><div className={pwdMatch ? 'text-success' : 'text-danger'}>{pwdMatch ? '✓' : '✕'} passwords match</div></div>}
                            </div>
                        </div>
                        {pwdMsg && <div className="mt-3 font-size-sm text-danger">{pwdMsg}</div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="me-3" variant="outline-secondary" onClick={() => setShowPasswordModal(false)}>Cancel</Button>
                        <Button variant="primary" type="submit" disabled={pwdLoading}>{pwdLoading ? 'Saving…' : 'Save'}</Button>
                    </Modal.Footer>
            </Form>
        </Modal>
    </>
);

export default ProfileAccountModals;
